var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 55,
    viewBox: "0 0 62 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5346 4.5116L60.6438 42.8826C61.1304 44.0279 61.3433 44.9592 61.4041 45.9267C61.5258 48.1872 60.7351 50.3844 59.1841 52.0753C57.6331 53.7601 55.5347 54.7547 53.2538 54.8752H8.73134C7.78858 54.818 6.84582 54.604 5.96389 54.2724C1.55422 52.4942 -0.574591 47.491 1.21969 43.1539L23.4809 4.48448C24.2412 3.12517 25.3969 1.95273 26.8262 1.19924C30.9622 -1.0944 36.2234 0.412589 38.5346 4.5116ZM33.6379 29.7989C33.6379 31.2457 32.4518 32.4543 30.9921 32.4543C29.5323 32.4543 28.3159 31.2457 28.3159 29.7989V21.2724C28.3159 19.8227 29.5323 18.6502 30.9921 18.6502C32.4518 18.6502 33.6379 19.8227 33.6379 21.2724V29.7989ZM30.9921 42.762C29.5323 42.762 28.3159 41.5534 28.3159 40.1097C28.3159 38.66 29.5323 37.4544 30.9921 37.4544C32.4518 37.4544 33.6379 38.6329 33.6379 40.0766C33.6379 41.5534 32.4518 42.762 30.9921 42.762Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.da7997e1.svg";
export { ForwardRef as ReactComponent };